import { BrowserRouter, Routes, Route, Navigate, useNavigate, useParams } from "react-router-dom";
import "@/App.css";
import { Planner } from "@/pages/Planner";
import { History } from "@/pages/History";
import { Settings } from "@/pages/Settings";
import { Pomodoro } from "@/pages/Pomodoro";
import { Landing } from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";
import { APP_TABS, Brand } from "@/lib/nav";

function TopNav({ active }) {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-30 bg-[#2f221d]/95 dark:bg-stone-950/90 backdrop-blur-xl border-b border-[#43302a] dark:border-stone-800">
      <div className="mx-auto max-w-md px-4 h-16 flex items-center justify-between">
        <Brand light />
        <nav className="flex items-center gap-1">
          {APP_TABS.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              data-testid={`nav-${id}`}
              onClick={() => navigate(`/app/${id}`)}
              title={label}
              className={`p-2 rounded-full transition-colors ${
                active === id ? "text-white bg-[#b1543b]" : "text-[#c3a99b] hover:text-white dark:text-stone-500"
              }`}
            >
              <Icon className="h-5 w-5" />
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
}

function AppShell() {
  const { tab = "today" } = useParams();
  if (!APP_TABS.some((t) => t.id === tab)) return <Navigate to="/app/today" replace />;
  return (
    <div className="min-h-screen bg-[#e7d2c4] dark:bg-stone-950 transition-colors">
      <TopNav active={tab} />
      <div className="mx-auto max-w-md px-4 pt-8 pb-16">
        {tab === "today" && <Planner />}
        {tab === "focus" && <Pomodoro />}
        {tab === "history" && <History />}
        {tab === "settings" && <Settings />}
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/app" element={<Navigate to="/app/today" replace />} />
        <Route path="/app/:tab" element={<AppShell />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}

export default App;
